export default __webpack_public_path__ + "static/media/10-2-record-video.104e1eef.png";